var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"czEmbed"},[_c('EmbeddedActions'),_c('div',{staticClass:"czEmbed__content"},[_vm._t("default")],2),_c('LoginRegisterDialog')],1)}
var staticRenderFns = []

export { render, staticRenderFns }